<div class="loading-phase">
  <div class="loading-containner">
    <img src="assets/images/loading.gif" alt="Carregando" />
  </div>
  <div class="animated-words">
    <span
      *ngFor="let phase of phases"
      [ngClass]="{
        'visible-phase-animation': phase === currentPhaseText,
        'hidden-phase': phase !== currentPhaseText,
        'hidden-phase-animation':
          phase !== currentPhaseText && phase === previousPhaseText
      }"
    >
      {{ phase }}
    </span>
  </div>
</div>
